export const getMetaCategoryCheckValue = (checksList: boolean[]) => {
  if (checksList.length === 0) {
    return 'none';
  }

  if (checksList.every(Boolean)) {
    return 'checked';
  }

  if (checksList.some(Boolean)) {
    return 'partiallyChecked';
  }

  return 'none';
};

export const getFlowStartingPointsCheckValues = (
  flowStartingPoints: Array<{ checks?: { name?: boolean; nodeName?: boolean } }>,
) =>
  flowStartingPoints.flatMap((point) => [
    Boolean(point.checks?.name),
    Boolean(point.checks?.nodeName),
  ]);

export const getPrototypeStartNodeCheckValues = (
  prototypeStartNode: { checks?: { name?: boolean; type?: boolean } } | null,
) => {
  if (!prototypeStartNode) {
    return [];
  }

  return [
    Boolean(prototypeStartNode.checks?.name),
    Boolean(prototypeStartNode.checks?.type),
  ];
};
